import React, { useState, useContext } from 'react';
import { UserAuthContext } from '../UserAuthContext';
import Header from "../components/Secciones/Header"
import Footer from "../components/Secciones/Footer"

const ForgotPasswordForm = () => {
  const { user } = useContext(UserAuthContext);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch('https://valleyapi-dr9y.onrender.com/api/send-reset-password-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();

      if (response.ok) {
        setMessage('Email Sent! Go check your email');
        setEmail('');
      } else {
        setError(data.error || 'Failed to send password reset email.');
      }
    } catch (err) {
      console.error('Fetch error:', err); // Debugging log
      setError('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          .forgot-password-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 50vh;
            background-color: #f4f4f4;
            padding: 20px;
          }
          .forgot-password-container {
            max-width: 400px;
            width: 100%;
            padding: 20px;
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .forgot-password-title {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 10px;
          }
          .forgot-password-description {
            text-align: center;
            font-size: 14px;
            color: #666;
            margin-bottom: 20px;
          }
          .forgot-password-input-container {
            margin-bottom: 20px;
          }
          .forgot-password-input {
            width: 100%;
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 4px;
            font-size: 14px;
            color: #333;
            box-sizing: border-box;
          }
          .forgot-password-input:focus {
            outline: none;
            border-color: #4a90e2;
            box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
          }
          .forgot-password-message {
            text-align: center;
            font-size: 14px;
            margin-bottom: 20px;
          }
          .forgot-password-success {
            color: #2e7d32;
          }
          .forgot-password-error {
            color: #d32f2f;
          }
          .forgot-password-button {
            width: 100%;
            padding: 10px;
            background-color: #4a90e2;
            color: #fff;
            border: none;
            border-radius: 4px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
          }
          .forgot-password-button:hover:not(:disabled) {
            background-color: #357abd;
          }
          .forgot-password-button:disabled {
            background-color: #90caf9;
            cursor: not-allowed;
          }
          .forgot-password-back-link {
            text-align: center;
            margin-top: 20px;
          }
          .forgot-password-back-link a {
            font-size: 14px;
            color: #4a90e2;
            text-decoration: none;
          }
          .forgot-password-back-link a:hover {
            color: #357abd;
            text-decoration: underline;
          }
        `}
      </style>
      <Header />
      <div className="forgot-password-wrapper">
        <div className="forgot-password-container">
          {user ? (
            <>
              <h2 className="forgot-password-title">Session Active</h2>
              <p className="forgot-password-message forgot-password-error">
                Log out to reset your password!
              </p>
            </>
          ) : message ? (
            <>
              <h2 className="forgot-password-title">Password Reset Requested</h2>
              <p className="forgot-password-message forgot-password-success">
                {message}
              </p>
              <div className="forgot-password-back-link">
              <a href="/">Back Home</a>
              </div>
            </>
          ) : (
            <>
              <h2 className="forgot-password-title">Forgot Your Password?</h2>
              <p className="forgot-password-description">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <div className="forgot-password-input-container">
                <label htmlFor="email" style={{ display: 'none' }}>Email address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="forgot-password-input"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              {error && <div className="forgot-password-message forgot-password-error">{error}</div>}
              <button
                className="forgot-password-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <div className="forgot-password-back-link">
                <a href="/"> Back Home</a>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPasswordForm;